import PropTypes from 'prop-types'
import styled from 'styled-components'

import { useField } from 'formik'
import Select from 'react-select'
import { Label } from '../../shared/styled_components/label'

export const FormikSelect = ({
  label,
  options,
  setFieldValue,
  onChange,
  dataTip,
  tooltipId,
  customClassName,
  noMargin = false,
  dataTestId,
  size,
  ...props
}) => {
  const [field, meta] = useField(props)

  const customChange = (value) => {
    if (onChange) {
      onChange(value)
    }
    setFieldValue(field.name, value)
  }

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      border: 'none',
      cursor: 'pointer',
      borderBottom: '1px solid #C4C4C4',
      borderRadius: '0',
      minHeight: 'unset',
      backgroundColor: 'transparent',
      '&:hover': {
        borderColor: '#C4C4C4',
        boxShadow: 'none'
      },
      '&:focus-within': {
        borderColor: '#C4C4C4',
        boxShadow: 'none'
      },
      '&:active': {
        borderColor: '#C4C4C4',
        boxShadow: 'none'
      }
    }),
    menu: (styles) => ({ ...styles, cursor: 'pointer', zIndex: '100', resize: 'both' }),
    menuList: (styles) => ({ ...styles, cursor: 'pointer' }),
    indicatorSeparator: (styles) => ({ ...styles, background: 'none' }),
    indicatorsContainer: (styles) => ({ ...styles, padding: '0' }),
    valueContainer: (styles) => ({ ...styles, padding: '0' }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'rgba(255, 205, 28, 0.17)' : 'transparent',
      '&:hover': { backgroundColor: 'rgba(255, 205, 28, 0.17)', cursor: 'pointer' },
      '&:active': { backgroundColor: 'rgba(255, 205, 28, 0.17)' },
      color: '#333333'
    })
  }

  const specificColourStyles = {
    control: (styles) => ({
      ...styles,
      border: 'none',
      cursor: 'pointer',
      borderBottom: '1px solid #C4C4C4',
      borderRadius: '0',
      minHeight: 'unset',
      backgroundColor: 'transparent',
      '&:hover': {
        borderColor: '#C4C4C4',
        boxShadow: 'none'
      },
      '&:focus-within': {
        borderColor: '#C4C4C4',
        boxShadow: 'none'
      },
      '&:active': {
        borderColor: '#C4C4C4',
        boxShadow: 'none'
      }
    }),
    menu: (styles) => ({
      ...styles,
      cursor: 'pointer',
      position: 'relative',
      bottom: '0',
      zIndex: '100',
      resize: 'both'
    }),
    menuList: (styles) => ({ ...styles, cursor: 'pointer' }),
    indicatorSeparator: (styles) => ({ ...styles, background: 'none' }),
    indicatorsContainer: (styles) => ({ ...styles, padding: '0' }),
    valueContainer: (styles) => ({ ...styles, padding: '0' }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'rgba(255, 205, 28, 0.17)' : 'transparent',
      '&:hover': { backgroundColor: 'rgba(255, 205, 28, 0.17)', cursor: 'pointer' },
      '&:active': { backgroundColor: 'rgba(255, 205, 28, 0.17)' },
      color: '#333333'
    })
  }

  return (
    <Label
      data-tooltip-id={tooltipId}
      data-tooltip-content={dataTip}
      $noMargin={noMargin}
      data-testid={dataTestId}
      $size={size}
    >
      {label && <span>{label}</span>}
      <CustomSelect
        isDisabled={props.disabled}
        placeholder="Sélectionner"
        styles={customClassName && customClassName === 'closing' ? specificColourStyles : colourStyles}
        name={field.name}
        value={field.value}
        onChange={customChange}
        {...props}
        options={options}
        className={meta.touched && meta.error ? 'error' : ''}
        noOptionsMessage={() => 'Aucune option'}
      />
      {meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
    </Label>
  )
}

FormikSelect.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({ label: PropTypes.string.isRequired, value: PropTypes.any.isRequired }),
      PropTypes.shape({ label: PropTypes.string.isRequired, options: PropTypes.array.isRequired })
    ])
  ).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  dataTip: PropTypes.string,
  tooltipId: PropTypes.string,
  customClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  noMargin: PropTypes.bool,
  dataTestId: PropTypes.string,
  size: PropTypes.string
}

const CustomSelect = styled(Select)`
  min-width: 190px;
  max-width: 345px;
  &-control:hover {
    border: none;
  }

  svg {
    height: 1.2rem;
  }
`
